__turbopack_context__.v({
  "dotGrid": "working-capital-module__nTIzbW__dotGrid",
  "flow": "working-capital-module__nTIzbW__flow",
  "flowDot": "working-capital-module__nTIzbW__flowDot",
  "gradientText": "working-capital-module__nTIzbW__gradientText",
});
